module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fmtitle"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }), _c('a', {
    attrs: {
      "id": "pageix"
    }
  }), _c('b', [_c('a', {
    attrs: {
      "href": "#/contents#rmap",
      "id": "map"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Maps")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "image2"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toc3"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/ch02#map1",
      "id": "rmap1"
    }
  }, [_vm._v("European Intrusions in North America")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc3"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch03#map2",
      "id": "rmap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Indigenous Mexico")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc3"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch03#map3",
      "id": "rmap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mexican States Mentioned in Chapter 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc3"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch04#map4",
      "id": "rmap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Indigenous Groups in the United States")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc3"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch05#map5",
      "id": "rmap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Indian Territory as Defined by the Royal Proclamation of 1763")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc3"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch05#map6",
      "id": "rmap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Canada")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc3"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch06#map7",
      "id": "rmap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Australia with Aboriginal Reserves")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc3"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch07#map8",
      "id": "rmap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Indonesia")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc3"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch07#map9",
      "id": "rmap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Namibia, Botswana, South Africa, Tanzania, and Kenya")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31984256","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map.vue
// module id = 72
// module chunks = 0